import classes from './NoData.module.css'
import React from "react";
import nodata from "../../assets/nodata.webp";

interface Props {
    width?: number,
    nobackground?: boolean,
}

export const NoData: React.FC<Props> = (props) => {
    return (<>
        <div className={props.nobackground ? classes.nobackground : classes.nodata}>
            <img width={`${props.width ? props.width : "400"}px`} src={nodata} alt=""/>
            <p className={classes.text}>لا يوجد بيانات الان</p>
        </div>
    </>);
}